<template>
  <div class="settings__table-paging flex center-all">
    <template v-if="loadMoreMode">
      <b-button
        v-if="loading || page < totalPages"
        class="flex center-all"
        @click="nextPage">
        <Spinner
          v-if="loading"
          :size="15"
          :thickness="2" />
        <SBIcon
          v-else
          class="mr-2"
          :icon="SBIconList.LOAD_MORE"
          :color="SBColors.blackPrimary"
          :size="12" />
        <span>Load more</span>
      </b-button>
    </template>
    <template v-else>
      <span class="greedy page-info">{{ page }} <span>of</span> {{ calcTotalPages }}</span>
      <div class="number-input flex center-all">
        <input
          v-if="totalPages > 5"
          v-model="inputPage"
          placeholder=""
          class="edit-field greedy"
          type="string"
          :size="inputSize"
          @change="setPage" >
        <b-button
          class="flex center-all"
          :disabled="page <= 1"
          @click="previousPage">
          <span>Back</span>
        </b-button>
        <b-button
          class="flex center-all"
          :disabled="page >= totalPages"
          @click="nextPage">
          <span>Next</span>
        </b-button>
      </div>
    </template>
  </div>
</template>
<script>
import Spinner from '@/components/common/Spinner';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';

export default {
  name: 'Paging',
  components: {
    Spinner,
    SBIcon,
  },
  props: {
    currentPage: {
      type: Number,
      required: false,
      default: 1,
    },
    totalPages: {
      type: Number,
      required: false,
      default: 1,
    },
    loadMoreMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      page: 1,
      inputPage: 1,
      SBColors,
      SBIconList,
    };
  },
  computed: {
    inputSize() {
      const minSize = 3;
      const maxSize = 7;

      return (this.inputPage.toString().length > minSize ? (this.inputPage.toString().length < maxSize ? this.inputPage.toString().length : maxSize) : minSize);
    },
    calcTotalPages() {
      // we need to display "page 1 of 1" instead of "page 1 of 0"
      return Math.max(this.totalPages, 1);
    },
  },
  watch: {
    currentPage() {
      this.page = this.currentPage;
      this.inputPage = this.currentPage;
    },
  },
  mounted() {
    this.page = this.currentPage;
    this.inputPage = this.currentPage;
  },
  methods: {
    nextPage() {
      if (this.page >= this.totalPages) {
        return;
      }
      this.page += 1;
      this.$emit('page', this.page);
    },
    previousPage() {
      if (this.page <= 1) {
        return;
      }
      this.page -= 1;
      this.$emit('page', this.page);
    },
    setPage() {
      const targetPage = Number.parseInt(this.inputPage, 10);
      if (Number.isNaN(targetPage) || targetPage < 1 || targetPage > this.totalPages) {
        this.inputPage = this.page;
        return;
      }
      this.page = targetPage;
      this.$emit('page', this.page);
    },
  },
};
</script>
<style lang="scss" scoped>
.settings__table-paging  {
  margin-top: 15px;
  margin-bottom: 15px;

  .page-info {
    font-size: 14px;
    font-weight: 500;
    color: $blackPrimary;

    span {
      font-weight: 400;
    }
  }

  .number-input {
    input {
      font-size: 14px;
      padding: 5px 10px;
      outline: none;
      height: 30px;
    }

    .btn {
      margin-left: 10px;
    }
  }

  .loader {
    width: unset;
    margin-right: 10px;
  }
}
</style>
